import React from 'react';

const Margin5vh = () => {
    return (
        <div className={"height-5"}/>
    );
};

export default Margin5vh;
